import React, { useState, useEffect } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import DataTable from "react-data-table-component";
import { get, post } from "../../services/api";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";
import { customTableStyles } from "../../assets/CustomTableStyles";
import DropdownWithCustomValuesModal from "../../components/DropdownWithCustomValuesModal";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import FullScreenLoader from "../../components/FullScreenLoader";
import AskConfirmationModal from "../../components/modals/AskConfirmationModal";
import ActivityApproveRejectConfirmationModal from "../../components/modals/ActivityApproveRejectConfirmationModal";
import PupilActivityEnrollmentModal from "./PupilActivityEnrollmentModal";
let currentDate = new Date();
function FacilityRentalCreationForm() {
  const token = localStorage.getItem("token");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const userId = localStorage.getItem("userId");
  const roleId = localStorage.getItem("roleId");

  const formViewOnlyUserRole = ["9", "10", "19", "25"].includes(roleId);

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [classSectionsData, setClassSectionsData] = useState([]);
  const [teachersData, setTeachersData] = useState([]);

  const [legalAgreementFileNameState, setLegalAgreementFileNameState] =
    useState("");
  const [termsFileNameState, setTermsFileNameState] = useState("");

  const [
    isCustomDropdownValuesModalVisible,
    setIsCustomDropdownValuesModalVisible,
  ] = useState(false);
  const [customDropdownName, setCustomDropdownName] = useState("");
  // TODO: Fetch this from your backend (e.g., CommonSettings)
  const invoiceFrequencyOptions = [
    { value: "Monthly", label: "Monthly" },
    { value: "Quarterly", label: "Quarterly" },
    { value: "Annually", label: "Annually" },
    { value: "One-time", label: "One-time" },
  ];
  const [allFacilities, setAllFacilities] = useState([]);
  // Add a new state to hold the dynamic data for each row
  const [rowSpecificData, setRowSpecificData] = useState({});

  const [isContractModalOpen, setIsContractModalOpen] = useState(false);

  const openContractModal = () => setIsContractModalOpen(true);
  const closeContractModal = () => setIsContractModalOpen(false);
  const [equipmentItems, setEquipmentItems] = useState([]);
  const handleFacilityChange = async (selectedOption, index) => {
    // If the user clears the dropdown, reset the row's data
    if (!selectedOption) {
      setValue(`facilityRentalDetails.${index}.facilityCode`, "");
      setValue(`facilityRentalDetails.${index}.authorizedRate`, "");
      setValue(`facilityRentalDetails.${index}.selectDaysFrom`, null);
      setValue(`facilityRentalDetails.${index}.selectDaysTo`, null);
      setValue(`facilityRentalDetails.${index}.timeSlot`, null);
      setRowSpecificData((prev) => ({ ...prev, [index]: null }));
      return;
    }

    const facilityId = selectedOption.value;

    // Auto-fill the read-only Facility Code
    // NEW CODE
    setValue(
      `facilityRentalDetails.${index}.facilityCode`,
      facilityId.toString()
    );

    try {
      const details = await get(`Facility/details/${facilityId}`);
      console.log("Fetched Details:", details);

      // Update the state that holds the options for this specific row's dropdowns
      setRowSpecificData((prev) => ({
        ...prev,
        [index]: {
          // --- THIS IS THE FIX ---
          // Prepare options for the Day From/To dropdowns
          availableDayOptions: details.availableDays.map((day) => ({
            value: day,
            label: day,
          })),

          // The existing logic for timeSlots remains the same
          timeSlots: details.timeRates.map((ts) => ({
            value: ts, // Store the WHOLE time slot object as the value
            label: `${ts.startTime} - ${ts.endTime} (${ts.type})`,
            rate: ts.perHourRate,
          })),
        },
      }));
    } catch (error) {
      console.error("Failed to fetch facility details:", error);
      toast.error("Could not load facility details.");
    }
  };

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    getValues,
    trigger,
    reset,
    setError,
  } = useForm({
    defaultValues: {
      id: 0,
      activityCode: "", // New Field
      providerOrganizartionName: "",
      providerContactName: "",
      providerEmail: "",
      providerPhone: "",
      vatId: "",
      rentalPurpose: "",
      facilityToBeRented: null,
      duration: "",
      expectedNumberOfAttendees: "",
      equipmentIncluded: "",
      rentalFee: "",
      rentalTerm: "",
      securityDepositFee: "",
      legalAgreementFileName: "",
      legalAgreementBase64String: "",
      legalAgreementPath: "",
      termsUploadPath: "",
      termsFileBase64String: "",
      termsFileName: "",
      schoolContactPerson: "",
      internalNotes: "",
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
      bookingForParent: false,
      serviceName: "",
      targetAge: "",
      parentFeePerStudent: null,
      minStudent: null,
      maxStudent: null,
      termsText: "",
      registrationOpenDate: null,
      registrationCloseDates: null,
      contractId: null,
      providerType: null,
      revenueShare: null,
      facilityRentalDetails: [
        {
          facilityId: null, // Mapped to Facility Name
          facilityCode: "", // New Field
          selectDaysFrom: null,
          selectDaysTo: null,
          timeSlot: null,
          authorizedRate: null,
          contractRate: null,
          invoiceFrequency: null,
          remarks: "",
        },
      ],
      equipmentRequired: [{ itemId: 0, itemName: "", quantity: 1, item: null }],
    },
  });

  const id = watch("id");

  useEffect(() => {
    // Only fetch a new code if it's a NEW record (id is 0)
    if (id === 0) {
      const fetchNextCode = async () => {
        try {
          const response = await get("CampusActivity/GetNextActivityCode", {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (response && response.nextCode) {
            setValue("activityCode", response.nextCode);
          }
        } catch (error) {
          console.error("Failed to fetch next activity code:", error);
        }
      };

      fetchNextCode();
    }
  }, [id, setValue]);
  useEffect(() => {
    const fetchFacilities = async () => {
      const response = await get("Facility");
      setAllFacilities(
        response.map((f) => ({ value: f.id, label: f.description }))
      );
    };
    fetchFacilities();
  }, []);

  // Fetch the items when the component loads
  useEffect(() => {
    const fetchEquipment = async () => {
      const items = await get("Items/rental-equipment", {
        headers: { Authorization: `Bearer ${token}` },
      }); // Use your new endpoint
      // Format for react-select
      const formattedItems = items.map((item) => ({
        value: item.itemId,
        label: `${item.itemName} (Stock: ${item.stock})`,
        stock: item.stock,
        name: item.itemName, // Store the plain name for saving
      }));
      setEquipmentItems(formattedItems);
    };
    fetchEquipment();
  }, []);

  // --- Add a NEW useFieldArray for the equipment ---
  const {
    fields: equipmentFields,
    append: appendEquipment,
    remove: removeEquipment,
  } = useFieldArray({
    control,
    name: "equipmentRequired", // This name must match the property in your DTO
  });

  const resetForm = () => {
    setTriggerRerender((prev) => !prev);
    setLegalAgreementFileNameState("");
    setTermsFileNameState("");
    reset({
      id: 0,
      activityCode: "",
      providerOrganizartionName: "",
      providerContactName: "",
      providerEmail: "",
      providerPhone: "",
      vatId: "",
      contractId: null,
      schoolContactPerson: "",
      internalNotes: "",
      termsText: "",
      rentalPurpose: "",
      equipmentIncluded: "",
      legalAgreementFileName: "",
      legalAgreementBase64String: "",
      termsFileName: "",
      termsFileBase64String: "",
      createdBy: localStorage.getItem("userId"),
      updatedBy: localStorage.getItem("userId"),
      facilityRentalDetails: [
        {
          facilityId: null,
          facilityCode: "",
          selectDaysFrom: null,
          selectDaysTo: null,
          timeSlotFrom: "",
          timeSlotTo: "",
          authorizedRate: null,
          contractRate: null,
          invoiceFrequency: null,
          remarks: "",
        },
      ],
    });
  };

  const [isConfimationModalOpen, setIsConfimationModalOpen] = useState(false);
  const [selectedActivityId, setSelectedActivityId] = useState(null);
  const [isConfirmApproveRejectModalOpen, setIsConfirmApproveRejectModalOpen] =
    useState(false);

  const [facilityRentedData, setFacilityRentedData] = useState([]);

  const [providerTypeData, setProviderTypeData] = useState([]);
  const [contractsData, setContractsData] = useState([]);

  const [loading, setLoading] = useState(false);

  const [dayAndTimeSlotsData, setDayAndTimeSlotsData] = useState([]);
  const [isEnrollModalOpen, setIsEnrollModalOpen] = useState(false);

  const fetchCommonSettings = async (moduleName, setData) => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=${moduleName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response?.commonSettingDetail);
    } catch (error) {
      console.error(`Error fetching ${moduleName}:`, error);
    }
  };

  useEffect(() => {
    fetchCommonSettings("facilityToBeRented", setFacilityRentedData);
    fetchCommonSettings("providerType", setProviderTypeData);
  }, [token]);

  const selectedProviderType = watch("providerType");

  useEffect(() => {
    if (selectedProviderType && selectedProviderType.value === "Internal") {
      setValue("revenueShare", null);
    }
  }, [selectedProviderType, setValue]);

  const [facilityRentalActiviesData, setFacilityRentalActiviesData] = useState(
    []
  );

  const getFacilityRentalActivitiesList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(
        `CampusActivity/GetAllActivityFacilityRental?roleId=${roleId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFacilityRentalActiviesData(response);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const getUsersByCenterIdAndRoleId = async () => {
    try {
      const response = await get(
        `UserAuthentication/GetUsersByCenterIdAndRoleId?centerId=${centerId}&roleId=${7}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTeachersData(response);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    }
  };

  const getContractsList = async () => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    try {
      const response = await get(`CampusContract/GetAllContracts`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setContractsData(response);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  useEffect(() => {
    getFacilityRentalActivitiesList();
    getUsersByCenterIdAndRoleId();
    getContractsList();
  }, [triggerRerender]);

  const handleEdit = async (activityId) => {
    try {
      setLoading(true); // Show a loading indicator

      // 1. Fetch the complete record from the API
      const activity = await get(
        `CampusActivity/GetActivityFacilityRentalById?id=${activityId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log("activity", JSON.stringify(activity));
      // This function assumes your API response 'activity' now includes two arrays:
      // activity.facilityRentalDetails
      // activity.equipmentRequired

      // 2. Find the full objects for top-level dropdowns to get their labels
      const selectedContract = contractsData.find(
        (c) => c.id === activity.contractId
      );
      // You can add similar logic for providerType if needed:
      // const selectedProviderType = providerTypeData.find(p => p.id === activity.providerType);

      // 3. Prepare the facilityRentalDetails array for the form
      // We must convert simple data (e.g., "Monday") into { value: "Monday", label: "Monday" }
      const preparedFacilityDetails = activity.facilityRentalDetails
        ? activity.facilityRentalDetails.map((detail) => {
            const facilityLabel =
              allFacilities.find((f) => f.value === detail.facilityId)?.label ||
              "";

            return {
              id: detail.id,
              facilityCode: detail.facilityCode,
              facilityId: { value: detail.facilityId, label: facilityLabel },
              selectDaysFrom: {
                value: detail.selectDaysFrom,
                label: detail.selectDaysFrom,
              },
              selectDaysTo: {
                value: detail.selectDaysTo,
                label: detail.selectDaysTo,
              },
              timeSlot: {
                value: {
                  startTime: detail.timeSlotFrom,
                  endTime: detail.timeSlotTo,
                },
                label: `${detail.timeSlotFrom} - ${detail.timeSlotTo}`,
                rate: detail.authorizedRate, // Pass the rate to the timeSlot object
              },
              authorizedRate: detail.authorizedRate,
              contractRate: detail.contractRate,
              invoiceFrequency: {
                value: detail.invoiceFrequency,
                label: detail.invoiceFrequency,
              },
              remarks: detail.remarks,
            };
          })
        : [];

      // 4. Prepare the equipmentRequired array for the form
      const preparedEquipment = activity.equipmentRequired
        ? activity.equipmentRequired.map((eq) => ({
            id: eq.id,
            itemId: eq.itemId,
            itemName: eq.itemName,
            quantity: eq.quantity,
            // Create the object that CreatableSelect expects
            item: { value: eq.itemId, label: eq.itemName, name: eq.itemName },
          }))
        : [];

      // 5. Update other UI states
      setLegalAgreementFileNameState(activity.legalAgreementFileName);
      setTermsFileNameState(activity.termsFileName);

      // 6. Reset the entire form with the fully prepared data
      reset({
        ...activity, // This sets all the simple fields like provider name, etc.

        // Override date fields to format them correctly (YYYY-MM-DD)
        registrationOpenDate: activity.registrationOpenDate?.split("T")[0],
        registrationCloseDates: activity.registrationCloseDates?.split("T")[0],

        // Override dropdown fields with the { value, label } objects we prepared
        contractId: selectedContract
          ? { value: selectedContract.id, label: selectedContract.name }
          : null,

        // Set the fully prepared arrays
        facilityRentalDetails: preparedFacilityDetails,
        equipmentRequired: preparedEquipment,

        updatedBy: localStorage.getItem("userId"),
      });
    } catch (error) {
      console.error("Error loading record for editing:", error);
      toast.error("Could not load record for editing.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (activityId) => {
    setSelectedActivityId(activityId);
    setIsConfimationModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsConfimationModalOpen(false);
    setSelectedActivityId(null);
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await post(
        `CampusActivity/DeleteActivityFacilityRental?id=${selectedActivityId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        resetForm();
      } else {
        toast.error(response.message || "An error occurred while deleting.");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
    } finally {
      setIsConfimationModalOpen(false);
      setSelectedActivityId(null);
    }
  };

  const handleActivityApproveOrReject = (activityId) => {
    setSelectedActivityId(activityId);
    setIsConfirmApproveRejectModalOpen(true);
  };

  const handleCloseActivityApproveRejectModal = () => {
    setIsConfirmApproveRejectModalOpen(false);
    setSelectedActivityId(null);
  };

  const handleConfirmApprove = async (
    roleId,
    activityId,
    approvalStatus,
    remarks
  ) => {
    let apiEndpoint;
    let formData = {
      id: activityId,
      activityName: "FacilityRental",
    };

    if (roleId === "25") {
      // COO
      apiEndpoint = "CampusActivity/CampusActivityApproval";
      formData.approvalStatus = approvalStatus;
      formData.remarks = remarks;
    } else if (roleId === "19") {
      // Accounts
      apiEndpoint = "CampusActivity/CampusActivityApprovalByAccount";
      formData.accountsApprovalStatus = approvalStatus;
      formData.accountsRemarks = remarks;
    } else {
      console.log("Error!");
      return;
    }

    setLoading(true);

    try {
      const response = await post(apiEndpoint, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.isSuccess) {
        toast.success("Success!");
        resetForm();
      } else {
        toast.error(response.message || "An error occurred.");
      }
    } catch (error) {
      console.error("Error approving/rejecting activity:", error);
    } finally {
      setIsConfirmApproveRejectModalOpen(false);
      setSelectedActivityId(null);
      setLoading(false);
    }
  };

  const handlePublishActivity = async (activityId) => {
    const formData = {
      id: activityId,
      activityName: "FacilityRental",
    };

    try {
      const response = await post(
        `CampusActivity/CampusActivityPublished`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        resetForm();
      } else {
        toast.error(response.message || "An error occurred.");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
    } finally {
      setIsConfirmApproveRejectModalOpen(false);
      setSelectedActivityId(null);
    }
  };

  const handleEnroll = async (activityId) => {
    setSelectedActivityId(activityId);

    try {
      const response = await get(
        `CampusActivity/GetActivityFacilityRentalById?id=${activityId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const activity = response;

      const slots = activity.campusActivityEventDatesDtos;

      setDayAndTimeSlotsData(slots);
      setIsEnrollModalOpen(true);

      console.log("Slots:", slots);
    } catch (error) {
      console.error("Error editing section:", error);
    }
  };

  const handleCloseEnrollModal = () => {
    setIsEnrollModalOpen(false);
    setSelectedActivityId(null);
  };

  const PERMISSIONS = {
    PARENT: {
      roleIds: ["9", "10"],
      actions: [
        {
          name: "view",
          icon: "fas fa-eye",
          handler: "handleEdit",
          tooltip: "View",
        },
        {
          name: "enroll",
          icon: "fas fa-user-plus",
          handler: "handleEnroll",
          tooltip: "Enroll",
        },
      ],
    },
    ACCOUNTS: {
      roleIds: ["19"],
      actions: [
        {
          name: "view",
          icon: "fas fa-eye",
          handler: "handleEdit",
          tooltip: "View",
        },
        {
          name: "approveReject",
          icon: "fas fa-question",
          handler: "handleActivityApproveOrReject",
          tooltip: "Approve/Reject",
          disabled: (row) =>
            ["Approved", "Rejected", "Published"].includes(row.status) ||
            ["Approved", "Rejected"].includes(row.accountsApprovalStatus),
        },
      ],
    },
    COO: {
      roleIds: ["25"],
      actions: [
        {
          name: "view",
          icon: "fas fa-eye",
          handler: "handleEdit",
          tooltip: "View",
        },
        {
          name: "approveReject",
          icon: "fas fa-question",
          handler: "handleActivityApproveOrReject",
          tooltip: "Approve/Reject",
          disabled: (row) =>
            ["Approved", "Rejected", "Published"].includes(row.status) ||
            row.cooApprovalStatus !== null,
        },
      ],
    },
    DEFAULT: {
      roleIds: [],
      actions: [
        {
          name: "edit",
          icon: "fas fa-pencil",
          handler: "handleEdit",
          tooltip: "Edit",
          disabled: (row) =>
            ["Approved", "Rejected"].includes(row.accountsApprovalStatus),
        },
        {
          name: "delete",
          icon: "fas fa-trash",
          handler: "handleDelete",
          tooltip: "Delete",
          disabled: (row) =>
            ["Approved", "Rejected"].includes(row.accountsApprovalStatus),
        },
        {
          name: "publish",
          icon: "fas fa-check-double",
          handler: "handlePublishActivity",
          tooltip: "Publish",
          visible: (row) =>
            row.isPublished === null &&
            row.accountsApprovalStatus === "Approved" &&
            row.cooApprovalStatus === "Approved",
        },
      ],
    },
  };

  const getActionsForRole = (roleId) => {
    const roleConfig = Object.values(PERMISSIONS).find(
      (role) => role.roleIds.length === 0 || role.roleIds.includes(roleId)
    );
    return roleConfig ? roleConfig.actions : [];
  };

  const actionColumn = {
    name: "Action",
    selector: (row, roleId, handlers) => {
      const actions = getActionsForRole(roleId);

      return (
        <div className="d-flex gap-1">
          {actions.map((action) => {
            if (action.visible && !action.visible(row)) {
              return null;
            }

            return (
              <button
                key={action.name}
                type="button"
                className={`btn p-0 border-0 custom-disabled-btn`}
                data-tooltip-id="global-tooltip"
                data-tooltip-content={action.tooltip}
                onClick={() => handlers[action.handler](row.id)}
                disabled={action.disabled && action.disabled(row)}
              >
                <i className={action.icon}></i>
              </button>
            );
          })}
        </div>
      );
    },
  };

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    {
      name: "Provider Org",
      selector: (row) => row.providerOrganizartionName,
      sortable: true,
      width: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.providerEmail,
      sortable: true,
      width: "150px",
    },
    {
      name: "Phone",
      selector: (row) => row.providerPhone,
      sortable: true,
      width: "150px",
    },
    {
      name: "Activity Status",
      selector: (row) => row.status,
      sortable: true,
      width: "150px",
    },
    {
      name: "Accounts Approval",
      selector: (row) => row.accountsApprovalStatus,
      sortable: true,
      width: "150px",
    },
    {
      name: "COO Approval",
      selector: (row) => row.cooApprovalStatus,
      sortable: true,
      width: "150px",
    },
    {
      ...actionColumn,
      selector: (row) =>
        actionColumn.selector(row, roleId, {
          handleEdit,
          handleActivityApproveOrReject,
          handleEnroll,
          handleDelete,
          handlePublishActivity,
        }),
    },
  ];

  const fetchClassSectionsByCenterId = async () => {
    try {
      if (centerId) {
        const response = await get(
          `ClassSection/GetAllClassSectionByCenterId?centerId=${centerId}&userId=${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setClassSectionsData(response);
      } else {
        setClassSectionsData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  useEffect(() => {
    fetchClassSectionsByCenterId();
  }, []);

  const handleCustomDropdownSetting = (dropdownName) => {
    setCustomDropdownName(dropdownName);
    setIsCustomDropdownValuesModalVisible(true);
  };

  const handleLegalFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setLegalAgreementFileNameState(file.name);

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setValue("legalAgreementBase64String", base64String, {
          shouldValidate: true,
        });
        trigger("legalAgreementFileName");
      };
      reader.readAsDataURL(file);
    } else {
      setLegalAgreementFileNameState("");
    }
  };

  const handleTermsFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setTermsFileNameState(file.name);

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setValue("termsFileBase64String", base64String, {
          shouldValidate: true,
        });
        trigger("termsFileName");
      };
      reader.readAsDataURL(file);
    } else {
      setTermsFileNameState("");
    }
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "facilityRentalDetails",
  });

  const [isBookingForParent, setIsBookingForParent] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsBookingForParent(e.target.checked);
  };

  useEffect(() => {
    if (!isBookingForParent) {
      setValue("serviceName", "");
      setValue("targetAge", "");
      setValue("minStudent", null);
      setValue("maxStudent", null);
      setValue("parentFeePerStudent", null);
      setValue("registrationOpenDate", null);
      setValue("registrationCloseDates", null);
    }
  }, [isBookingForParent, setValue]);

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    // --- START: DATA TRANSFORMATION ---
    const payload = {
      // Base entity fields for the main record
      createdOn: data.id === 0 ? currentDate : data.createdOn,
      createdBy: data.id === 0 ? userId : data.createdBy,
      updatedOn: currentDate,
      updatedBy: userId,

      // Main Information fields from the form
      contractId: data.contractId?.value || 0,
      providerType: data.providerType?.value || 0,
      revenueShare: data.revenueShare ? parseInt(data.revenueShare, 10) : 0,
      id: data.id || 0,
      providerOrganizartionName: data.providerOrganizartionName || "",
      providerContactName: data.providerContactName || "",
      providerEmail: data.providerEmail || "",
      providerPhone: data.providerPhone || "",
      vatId: data.vatId || "",
      rentalPurpose: data.rentalPurpose || "",
      duration: data.duration ? parseInt(data.duration, 10) : 0,
      expectedNumberOfAttendees: data.expectedNumberOfAttendees
        ? parseInt(data.expectedNumberOfAttendees, 10)
        : 0,
      equipmentIncluded: data.equipmentIncluded || "",
      rentalFee: data.rentalFee ? parseInt(data.rentalFee, 10) : 0,
      rentalTerm: data.rentalTerm || "",
      securityDepositFee: data.securityDepositFee
        ? parseInt(data.securityDepositFee, 10)
        : 0,
      legalAgreementFileName: data.legalAgreementFileName || "",
      legalAgreementBase64String: data.legalAgreementBase64String || "",
      legalAgreementPath: data.legalAgreementPath || "",
      termsUploadPath: data.termsUploadPath || "",
      termsFileBase64String: data.termsFileBase64String || "",
      termsFileName: data.termsFileName || "",
      schoolContactPerson: data.schoolContactPerson || "",
      internalNotes: data.internalNotes || "",
      bookingForParent: data.bookingForParent || false,
      serviceName: data.serviceName || "",
      targetAge: data.targetAge || "",
      parentFeePerStudent: data.parentFeePerStudent
        ? parseInt(data.parentFeePerStudent, 10)
        : 0,
      minStudent: data.minStudent ? parseInt(data.minStudent, 10) : 0,
      maxStudent: data.maxStudent ? parseInt(data.maxStudent, 10) : 0,
      termsText: data.termsText || "",
      registrationOpenDate: data.registrationOpenDate || null,
      registrationCloseDates: data.registrationCloseDates || null,
      isCooApproved: data.isCooApproved || false,
      remarks: data.remarks || "",
      status: data.status || "Draft",
      isPublished: data.isPublished || false,
      accountStatus: data.accountStatus || "",
      cooApprovalStatus: data.cooApprovalStatus || "",
      cooApprovalRemarks: data.cooApprovalRemarks || "",
      accountsRemarks: data.accountsRemarks || "",
      accountsApprovalStatus: data.accountsApprovalStatus || "",
      activityCode: data.activityCode || "",

      // The nested array for Facility Details
      facilityRentalDetails: data.facilityRentalDetails.map((detail) => ({
        id: detail.id || 0,
        createdOn: detail.id === 0 ? currentDate : detail.createdOn,
        createdBy: userId,
        updatedOn: currentDate,
        updatedBy: userId,
        facilityCode: detail.facilityCode || "",
        facilityId: detail.facilityId.value || 0,
        selectDaysFrom: detail.selectDaysFrom?.value || "",
        selectDaysTo: detail.selectDaysTo?.value || "",
        timeSlotFrom: detail.timeSlot?.value?.startTime || "",
        timeSlotTo: detail.timeSlot?.value?.endTime || "",
        authorizedRate: detail.authorizedRate || 0,
        contractRate: detail.contractRate
          ? parseInt(detail.contractRate, 10)
          : 0,
        invoiceFrequency: detail.invoiceFrequency?.value || "",
        remarks: detail.remarks || "",
      })),

      // The nested array for Equipment Required
      equipmentRequired: data.equipmentRequired
        ? data.equipmentRequired.map((eq) => ({
            itemId: eq.itemId || 0,
            itemName: eq.itemName || "",
            quantity: eq.quantity ? parseInt(eq.quantity, 10) : 0,
            createdOn: currentDate,
            createdBy: userId,
          }))
        : [], // Send an empty array if no equipment was added
    };
    // --- END: DATA TRANSFORMATION ---

    console.log("Final Payload to be sent:", JSON.stringify(payload));

    setLoading(true);
    try {
      const response = await post(
        "CampusActivity/AddUpdateActivityFacilityRental",
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.isSuccess) {
        toast.success("Facility Rental Saved Successfully!");
        resetForm();
      } else {
        toast.error(response.message || "An unexpected error occurred");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Failed to save data.");
    } finally {
      setLoading(false);
    }
  };
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showActivityDetailsModal, setShowActivityDetailsModal] =
    useState(false);

  const fetchEvents = (fetchInfo, successCallback, failureCallback) => {
    get(`CampusActivity/GetAllActivityFacilityRental?roleId=${roleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((response) => {
        if (Array.isArray(response)) {
          const allEvents = response.map((activity) => {
            const eventDateTime = new Date(activity.registrationOpenDate);
            // const endDateTime = new Date(activity.endDate);

            // endDateTime.setDate(endDateTime.getDate() + 1);

            return {
              id: activity.id,
              title: activity.providerOrganizartionName,
              start: eventDateTime.toISOString(),
              // end: endDateTime.toISOString(),
              extendedProps: {
                providerOrganizartionName: activity.providerOrganizartionName,
                description: activity.description,
                maxStudents: activity.maxStudents,
                minStudents: activity.minStudents,
                feesPerStudent: activity.feesPerStudent,
                registrationOpenDate: activity.registrationOpenDate,
                registrationClose: activity.registrationClose,
                materialsRequired: activity.materialsRequired,
                contactName: activity.contactName,
                email: activity.email,
                phone: activity.phone,
              },
            };
          });

          successCallback(allEvents);
        } else {
          failureCallback(new Error("Unexpected response format"));
        }
      })
      .catch((error) => {
        console.error("Error fetching events:", error);
        failureCallback(error);
      });
  };

  const handleEventClick = (clickInfo) => {
    const { event } = clickInfo;

    setSelectedEvent({
      providerOrganizartionName: event.extendedProps.providerOrganizartionName,
      description: event.extendedProps.description,
      maxStudents: event.extendedProps.maxStudents,
      minStudents: event.extendedProps.minStudents,
      feesPerStudent: event.extendedProps.feesPerStudent,
      registrationOpenDate: event.extendedProps.registrationOpenDate,
      registrationClose: event.extendedProps.registrationClose,
      materialsRequired: event.extendedProps.materialsRequired,
      contactName: event.extendedProps.contactName,
      email: event.extendedProps.email,
      phone: event.extendedProps.phone,
      eventDate: event.eventDate,
      endDate: event.endDate,
    });

    setShowActivityDetailsModal(true);
  };

  const handleCloseActivityDetailsModal = () => {
    setShowActivityDetailsModal(false);
    setSelectedEvent(null);
  };

  return (
    <>
      <div className="row g-3">
        <div className="col-md-12">
          <div className="card h-100">
            <div className="card-body">
              <h4 className="mb-3 fs-8">Facility Rental</h4>
              <div
                className={`position-relative ${
                  formViewOnlyUserRole ? "p-3" : ""
                }`}
                style={formViewOnlyUserRole ? { pointerEvents: "none" } : {}}
              >
                {formViewOnlyUserRole && (
                  <div
                    className="p-3 form-overlay position-absolute top-0 start-0 w-100 h-100"
                    style={{
                      backgroundColor: "rgba(0, 0, 0, 0.03)",
                      zIndex: 10,
                    }}
                  ></div>
                )}

                <form
                  className="new-form-style"
                  onSubmit={handleSubmit(saveData)}
                >
                  <div className="row g-3">
                    {/* SECTION 1: INFORMATION */}
                    <div className="col-12">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="mb-3">Information</h5>
                          <div className="row g-3">
                            <div className="col-md-3">
                              <label className="form-label form-label-new">
                                Activity Code
                              </label>
                              <input
                                {...register("activityCode")}
                                type="text"
                                className="form-control"
                                readOnly
                                placeholder="Auto-generated"
                              />
                            </div>
                            <div className="col-md-3">
                              <label className="form-label form-label-new">
                                Customer Name{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                {...register("providerOrganizartionName", {
                                  required: "Customer Name is required.",
                                })}
                                type="text"
                                className="form-control"
                              />
                              {errors.providerOrganizartionName && (
                                <small className="text-danger">
                                  {errors.providerOrganizartionName.message}
                                </small>
                              )}
                            </div>
                            <div className="col-md-3">
                              <label className="form-label form-label-new">
                                VAT/Tax ID
                              </label>
                              <input
                                {...register("vatId")}
                                type="text"
                                className="form-control"
                              />
                            </div>
                            <div className="col-md-3">
                              <label className="form-label form-label-new">
                                Contract Attach{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <div className="d-flex">
                                {" "}
                                {/* This container places the items side-by-side */}
                                <div className="flex-grow-1">
                                  {" "}
                                  {/* This makes the dropdown take up the available space */}
                                  <Controller
                                    name="contractId"
                                    control={control}
                                    rules={{
                                      required: "Contract is required.",
                                    }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={contractsData.map((c) => ({
                                          value: c.id,
                                          label: c.name,
                                        }))}
                                        className="react-select-style"
                                        classNamePrefix="react-select-style-pref"
                                        isClearable
                                      />
                                    )}
                                  />
                                </div>
                                <button
                                  type="button"
                                  className="btn"
                                  onClick={openContractModal}
                                >
                                  <i className="fas fa-plus"></i>
                                </button>
                              </div>
                              {errors.contractId && (
                                <small className="text-danger">
                                  {errors.contractId.message}
                                </small>
                              )}
                            </div>
                            <div className="col-md-3">
                              <label className="form-label form-label-new">
                                Contact Person{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                {...register("providerContactName", {
                                  required: "Contact Person is required.",
                                })}
                                type="text"
                                className="form-control"
                              />
                              {errors.providerContactName && (
                                <small className="text-danger">
                                  {errors.providerContactName.message}
                                </small>
                              )}
                            </div>
                            <div className="col-md-3">
                              <label className="form-label form-label-new">
                                Contact Person Email{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                {...register("providerEmail", {
                                  required: "Email is required.",
                                  pattern: {
                                    value: /^\S+@\S+$/i,
                                    message: "Invalid email address",
                                  },
                                })}
                                type="email"
                                className="form-control"
                              />
                              {errors.providerEmail && (
                                <small className="text-danger">
                                  {errors.providerEmail.message}
                                </small>
                              )}
                            </div>
                            <div className="col-md-3">
                              <label className="form-label form-label-new">
                                Contact Person Phone{" "}
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                {...register("providerPhone", {
                                  required: "Phone is required.",
                                })}
                                type="text"
                                className="form-control"
                              />
                              {errors.providerPhone && (
                                <small className="text-danger">
                                  {errors.providerPhone.message}
                                </small>
                              )}
                            </div>
                            <div className="col-md-3">
                              <label className="form-label form-label-new">
                                Our Contact Person
                              </label>
                              <input
                                {...register("schoolContactPerson")}
                                type="text"
                                className="form-control"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label form-label-new">
                                Rental Purpose
                              </label>
                              <textarea
                                {...register("rentalPurpose")}
                                className="form-control"
                                rows="1"
                              ></textarea>
                            </div>
                            <div className="col-md-6">
                              {/* --- 1. ADDED THE HEADERS YOU REQUESTED --- */}
                              <div className="row g-3">
                                <div className="col-md-6">
                                  <label className="form-label form-label-new fw-bold">
                                    Equipment Required
                                  </label>
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label form-label-new fw-bold">
                                    Quantity
                                  </label>
                                </div>
                                <div className="col-md-2">
                                  <label
                                    className="form-label fw-bold"
                                    style={{ marginLeft: "10px" }}
                                  >
                                    Action
                                  </label>
                                </div>
                              </div>

                              {/* This is your original .map() loop */}
                              {equipmentFields.map((field, index) => (
                                <div
                                  key={field.id}
                                  className="row g-3 mb-2 align-items-center"
                                >
                                  {/* These hidden fields are unchanged */}
                                  <input
                                    type="hidden"
                                    {...register(
                                      `equipmentRequired.${index}.itemId`
                                    )}
                                  />
                                  <input
                                    type="hidden"
                                    {...register(
                                      `equipmentRequired.${index}.itemName`
                                    )}
                                  />

                                  {/* --- 2. DROPDOWN IS NOW col-md-6 --- */}
                                  <div className="col-md-6">
                                    <Controller
                                      name={`equipmentRequired.${index}.item`}
                                      control={control}
                                      render={({ field }) => (
                                        <CreatableSelect
                                          {...field}
                                          isClearable
                                          options={equipmentItems}
                                          onChange={(selectedOption) => {
                                            field.onChange(selectedOption);
                                            if (selectedOption) {
                                              if (selectedOption.__isNew__) {
                                                setValue(
                                                  `equipmentRequired.${index}.itemId`,
                                                  0
                                                );
                                                setValue(
                                                  `equipmentRequired.${index}.itemName`,
                                                  selectedOption.label
                                                );
                                              } else {
                                                setValue(
                                                  `equipmentRequired.${index}.itemId`,
                                                  selectedOption.value
                                                );
                                                setValue(
                                                  `equipmentRequired.${index}.itemName`,
                                                  selectedOption.name
                                                );
                                              }
                                            } else {
                                              setValue(
                                                `equipmentRequired.${index}.itemId`,
                                                0
                                              );
                                              setValue(
                                                `equipmentRequired.${index}.itemName`,
                                                ""
                                              );
                                            }
                                          }}
                                          className="react-select-style"
                                          classNamePrefix="react-select-style-pref"
                                        />
                                      )}
                                    />
                                  </div>

                                  {/* Quantity input is unchanged */}
                                  <div className="col-md-4">
                                    <input
                                      type="number"
                                      {...register(
                                        `equipmentRequired.${index}.quantity`,
                                        { required: true, valueAsNumber: true }
                                      )}
                                      className="form-control"
                                      placeholder="Quantity"
                                    />
                                  </div>

                                  {/* --- 3. BUTTONS ARE STYLED AS REQUESTED --- */}
                                  <div className="col-md-2">
                                    <div style={{ display: "flex" }}>
                                      {/* ADD Button with styles to join it to the next button */}
                                      <button
                                        type="button"
                                        className="btn"
                                        onClick={() =>
                                          appendEquipment({
                                            itemId: 0,
                                            itemName: "",
                                            quantity: 1,
                                            item: null,
                                          })
                                        }
                                        style={{
                                          margin: 0,
                                          borderTopRightRadius: 0,
                                          borderBottomRightRadius: 0,
                                        }}
                                      >
                                        <i className="fas fa-plus"></i>
                                      </button>

                                      {equipmentFields.length > 1 && (
                                        <button
                                          type="button"
                                          className="btn "
                                          onClick={() => removeEquipment(index)}
                                          style={{
                                            margin: "-20px",
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                          }}
                                        >
                                          <i className="fas fa-trash"></i>
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="col-md-6">
                              <label className="form-label form-label-new">
                                Internal Notes
                              </label>
                              <textarea
                                {...register("internalNotes")}
                                className="form-control"
                                rows="1"
                              ></textarea>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label form-label-new">
                                Terms / Rules
                              </label>
                              <textarea
                                {...register("termsText")}
                                className="form-control"
                                rows="1"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* SECTION 2: DETAILED INFORMATION */}

                    <div className="col-12">
                      <div className="card">
                        <div className="card-body">
                          <h5 className="mb-3">Detailed Information</h5>
                          {fields.map((field, index) => (
                            <div
                              key={field.id}
                              className="mb-3 p-3 border rounded"
                            >
                              {/* --- LINE 1 OF INPUTS --- */}
                              <div className="row g-3 mb-2">
                                <div className="col-md-2">
                                  <label className="form-label form-label-new">
                                    Facility Code
                                  </label>
                                  <input
                                    {...register(
                                      `facilityRentalDetails.${index}.facilityCode`
                                    )}
                                    className="form-control"
                                    placeholder="Auto"
                                    readOnly
                                  />
                                </div>

                                <div className="col-md-2">
                                  <label className="form-label form-label-new">
                                    Facility Name
                                  </label>
                                  <Controller
                                    name={`facilityRentalDetails.${index}.facilityId`}
                                    control={control}
                                    rules={{
                                      required: "Facility is required.",
                                    }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={allFacilities}
                                        onChange={(selectedOption) => {
                                          field.onChange(selectedOption);
                                          handleFacilityChange(
                                            selectedOption,
                                            index
                                          );
                                        }}
                                        // --- STYLE FIX ---
                                        className="react-select-style"
                                        classNamePrefix="react-select-style-pref"
                                        isClearable
                                      />
                                    )}
                                  />
                                </div>

                                <div className="col-md-2">
                                  <label className="form-label form-label-new">
                                    Day From
                                  </label>
                                  <Controller
                                    name={`facilityRentalDetails.${index}.selectDaysFrom`}
                                    control={control}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={
                                          rowSpecificData[index]
                                            ?.availableDayOptions || []
                                        }
                                        // --- STYLE FIX ---
                                        className="react-select-style"
                                        classNamePrefix="react-select-style-pref"
                                      />
                                    )}
                                  />
                                </div>

                                <div className="col-md-2">
                                  <label className="form-label form-label-new">
                                    Day To
                                  </label>
                                  <Controller
                                    name={`facilityRentalDetails.${index}.selectDaysTo`}
                                    control={control}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={
                                          rowSpecificData[index]
                                            ?.availableDayOptions || []
                                        }
                                        // --- STYLE FIX ---
                                        className="react-select-style"
                                        classNamePrefix="react-select-style-pref"
                                      />
                                    )}
                                  />
                                </div>

                                {/* --- NEW: Combined Time Slot Dropdown --- */}
                                <div className="col-md-4">
                                  <label className="form-label form-label-new">
                                    Time Slot
                                  </label>
                                  <Controller
                                    name={`facilityRentalDetails.${index}.timeSlot`}
                                    control={control}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={
                                          rowSpecificData[index]?.timeSlots ||
                                          []
                                        }
                                        onChange={(option) => {
                                          field.onChange(option);
                                          setValue(
                                            `facilityRentalDetails.${index}.authorizedRate`,
                                            option.rate
                                          );
                                        }}
                                        // --- STYLE FIX ---
                                        className="react-select-style"
                                        classNamePrefix="react-select-style-pref"
                                      />
                                    )}
                                  />
                                </div>
                              </div>

                              {/* --- LINE 2 OF INPUTS --- */}
                              <div className="row g-3">
                                <div className="col-md-2">
                                  <label className="form-label form-label-new">
                                    Auth. Rate
                                  </label>
                                  <input
                                    {...register(
                                      `facilityRentalDetails.${index}.authorizedRate`
                                    )}
                                    type="number"
                                    className="form-control"
                                    placeholder="Auto"
                                    readOnly
                                  />
                                </div>
                                <div className="col-md-2">
                                  <label className="form-label form-label-new">
                                    Cont. Rate
                                  </label>
                                  <input
                                    {...register(
                                      `facilityRentalDetails.${index}.contractRate`
                                    )}
                                    type="number"
                                    className="form-control"
                                    placeholder="Cont. Rate"
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label form-label-new">
                                    Inv. Freq.
                                  </label>
                                  <Controller
                                    name={`facilityRentalDetails.${index}.invoiceFrequency`}
                                    control={control}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={invoiceFrequencyOptions}
                                        className="react-select-style"
                                        classNamePrefix="react-select-style-pref"
                                        placeholder="Inv. Freq."
                                      />
                                    )}
                                  />
                                </div>
                                <div className="col-md-3">
                                  <label className="form-label form-label-new">
                                    Remarks
                                  </label>
                                  <input
                                    {...register(
                                      `facilityRentalDetails.${index}.remarks`
                                    )}
                                    className="form-control"
                                    placeholder="Remarks"
                                  />
                                </div>
                                <div className="col-md-2">
                                  {fields.length > 1 ? (
                                    <label className="form-label">Action</label>
                                  ) : (
                                    // This is a placeholder to prevent the layout from shifting when there's only one row
                                    <></>
                                  )}
                                  <div>
                                    {fields.length > 1 ? (
                                      <button
                                        type="button"
                                        className="btn"
                                        onClick={() => remove(index)}
                                      >
                                        <i className="fas fa-trash"></i>
                                      </button>
                                    ) : (
                                      // This is a placeholder to prevent the layout from shifting when there's only one row
                                      <button
                                        type="button"
                                        disabled
                                        style={{ visibility: "hidden" }}
                                      >
                                        <i className="fas fa-trash"></i>
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                          <button
                            type="button"
                            className="btn btn-primary mt-2"
                            onClick={() =>
                              append({
                                facilityId: null,
                                facilityCode: "",
                                selectDaysFrom: null,
                                selectDaysTo: null,
                                timeSlot: null,
                                authorizedRate: null,
                                contractRate: null,
                                invoiceFrequency: null,
                                remarks: "",
                              })
                            }
                          >
                            <i className="fas fa-plus"></i> Add Row
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting || loading}
                      >
                        {loading ? "Saving..." : "Save Facility Rental"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary ms-2"
                        onClick={resetForm}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="col-md-6">
          <div className="calendar-container h-100">
            <FullCalendar
              plugins={[dayGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              events={fetchEvents}
              // eventClick={handleEventClick}
              dayMaxEvents={1}
              height="auto"
              eventDisplay="block"
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "dayGridMonth",
              }}
              eventTimeFormat={{
                hour: "2-digit",
                minute: "2-digit",
                meridiem: true,
              }}
            />
          </div>
        </div> */}

        <div className="col-md-12">
          <div className="card h-100">
            <div className="card-body">
              <div className="table-container fixed-last-column-table">
                <DataTable
                  columns={columns}
                  data={facilityRentalActiviesData}
                  pagination
                  paginationPerPage={rowsPerPage}
                  paginationRowsPerPageOptions={[10, 20, 30, 40, 50]}
                  dense
                  customStyles={customTableStyles}
                  highlightOnHover={true}
                  onChangePage={setCurrentPage}
                  onChangeRowsPerPage={setRowsPerPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* --- Add New Contract Modal --- */}
      {isContractModalOpen && (
        <div
          className="modal show fade"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Contract</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeContractModal} // This closes the modal
                ></button>
              </div>
              <div className="modal-body"></div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeContractModal} // This also closes the modal
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Save Contract
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* The modal backdrop */}
      {isContractModalOpen && <div className="modal-backdrop fade show"></div>}

      {isCustomDropdownValuesModalVisible && (
        <DropdownWithCustomValuesModal
          dropdownName={customDropdownName}
          onClose={() => {
            setIsCustomDropdownValuesModalVisible(false);
            if (customDropdownName === "facilityToBeRented") {
              fetchCommonSettings("facilityToBeRented", setFacilityRentedData);
            } else if (customDropdownName === "providerType") {
              fetchCommonSettings("providerType", setProviderTypeData);
            }
          }}
        />
      )}

      {isConfimationModalOpen && (
        <AskConfirmationModal
          handleClose={handleCloseModal}
          handleConfirm={handleConfirmDelete}
          message="Are you sure you want to delete this record?"
        />
      )}

      {isConfirmApproveRejectModalOpen && (
        <ActivityApproveRejectConfirmationModal
          handleClose={handleCloseActivityApproveRejectModal}
          handleConfirm={(approvalStatus, remarks) =>
            handleConfirmApprove(
              roleId,
              selectedActivityId,
              approvalStatus,
              remarks
            )
          }
          roleId={roleId}
          isLoading={loading}
        />
      )}

      {isEnrollModalOpen && (
        <PupilActivityEnrollmentModal
          handleClose={handleCloseEnrollModal}
          selectedActivityId={selectedActivityId}
          selectedActivityType="FacilityRental"
          activitiesData={facilityRentalActiviesData}
          nameField="providerOrganizartionName"
          slots={dayAndTimeSlotsData}
        />
      )}

      {loading && <FullScreenLoader />}
    </>
  );
}

export default FacilityRentalCreationForm;
